// @mui
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
// components
import React, { forwardRef } from 'react';
import { CustomTextField } from 'src/components/custom-input';
import { useLocales } from 'src/locales';
import Iconify from '../../../../components/iconify';

type Props = {
  filterName: string;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit?: () => void;
  onClearInput?: () => void;
  isNavSearch?: boolean;
  clearInput?: boolean;
};

export const FileFilterName = forwardRef<HTMLDivElement, Props>(
  (
    {
      filterName,
      onFilterName,
      onSubmit,
      isNavSearch,
      clearInput,
      onClearInput,
    }: Props,
    ref,
  ) => {
    const { translate } = useLocales();
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter' && onSubmit) {
        event.preventDefault();
        onSubmit();
      }
    };
    if (isNavSearch)
      return (
        <CustomTextField
          size="medium"
          fullWidth
          value={filterName}
          onChange={onFilterName}
          onKeyDown={handleKeyDown}
          placeholder={translate('header.nav_vertical.search_placeholder')}
          ref={ref}
          sx={{
            '& .MuiOutlinedInput-root': {
              border: 'none',
              transition: 'none',
              pl: 0.5,
            },
            '&.Mui-focused': {
              boxShadow: 'none',
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ width: 24, height: 24, color: 'text.disabled' }}
                />
              </InputAdornment>
            ),
            endAdornment: filterName && (
              <InputAdornment position="end">
                <IconButton onClick={onSubmit} size="small">
                  <Iconify
                    icon="eva:arrow-circle-right-fill"
                    sx={{ color: 'text.disabled' }}
                  />
                </IconButton>
              </InputAdornment>
            ),
            inputProps: {
              style: {
                fontSize: 14,
              },
            },
          }}
        />
      );

    return (
      <TextField
        size="small"
        ref={ref}
        value={filterName}
        onChange={onFilterName}
        onKeyDown={handleKeyDown}
        fullWidth
        placeholder={translate('shared.search')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          ),
          endAdornment: filterName && (
            <InputAdornment position="end">
              <Tooltip placement="top" title={clearInput ? 'Clear' : 'Submit'}>
                <IconButton
                  onClick={clearInput ? onClearInput : onSubmit}
                  size="small"
                >
                  <Iconify
                    icon={
                      clearInput
                        ? 'tabler:circle-x-filled'
                        : 'eva:arrow-circle-right-fill'
                    }
                    sx={{ color: 'text.disabled' }}
                  />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
      />
    );
  },
);
